import { render, staticRenderFns } from "./MediaPanel.vue?vue&type=template&id=674f939c&scoped=true&"
import script from "./MediaPanel.vue?vue&type=script&lang=js&"
export * from "./MediaPanel.vue?vue&type=script&lang=js&"
import style0 from "./MediaPanel.vue?vue&type=style&index=0&id=674f939c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f939c",
  null
  
)

export default component.exports